module.exports = __webpack_public_path__ + "static/media/quotecard_climate_controlled_img.9a958860.webp";